module.exports = "<!-- RIBBON -->\r\n<div id=\"ribbon\">\r\n  <ng-template #tipContent><i class=\"text-warning fa fa-warning\"></i> Warning! This will reset all your widget\r\n    settings.</ng-template>\r\n\r\n  <span class=\"ribbon-button-alignment\">\r\n    <span id=\"refresh\" class=\"btn btn-ribbon\" (click)=\"resetWidgets()\" placement=\"bottom\" [tooltip]=\"tipContent\">\r\n      <i class=\"fa fa-refresh\"></i>\r\n    </span>\r\n  </span>\r\n  <sa-route-breadcrumbs></sa-route-breadcrumbs>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/ribbon/ribbon.component.html
// module id = 883
// module chunks = 29